export default "assets/images/icons/marker-4ea21e14.svg";